import styles from "cc-frontend/components/planner/card-stacks/lesson-loading.module.css"

/** The lesson slot's loading skeleton — the React twin of `Planner::CardStacks::LessonLoading`. */
export default function LessonLoading() {
  return (
    <div className={styles["lesson-outer"]}>
      <div className={styles["lesson"]}>
        <div className={`loading-bars ${styles["course-title"]}`}></div>
        <div className={`loading-bars ${styles["lesson-title"]}`}></div>
        <div className={`loading-bars ${styles["cards-area"]}`}></div>
      </div>
    </div>
  )
}
